import { render, staticRenderFns } from "./Duplicated.vue?vue&type=template&id=1c420207&scoped=true&"
import script from "./Duplicated.vue?vue&type=script&lang=js&"
export * from "./Duplicated.vue?vue&type=script&lang=js&"
import style0 from "./Duplicated.vue?vue&type=style&index=0&id=1c420207&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c420207",
  null
  
)

export default component.exports